import React, { useState, useEffect } from 'react';
import '../styles/Countdown.css';

const Countdown_target = new Date("2025-10-30T23:59:59");

const getTimeLeft = () => {
    const totalTimeLeft = Countdown_target - new Date();

    if (totalTimeLeft <= 0) {
        return { Hours: "00" , Minutes: "00" , Seconds: "00" };
    }

    const totalSeconds = Math.floor(totalTimeLeft / 1000);
    const Hours = Math.floor(totalSeconds / 3600);
    const Minutes = Math.floor((totalSeconds % 3600) / 60);
    const Seconds = (totalSeconds % 60);

    return {
        Hours: String(Hours).padStart(2, "0"),
        Minutes: String(Minutes).padStart(2, "0"),
        Seconds: String(Seconds).padStart(2, "0"),
    };
};

function Countdown() {

const [TimeLeft , setTimeLeft] = useState(() => getTimeLeft());

useEffect(() => {
    const timer = setInterval(() => {
        setTimeLeft(getTimeLeft())
    }, 1000)

    return() => {
        clearInterval(timer)
    };
}, []);

  return (
    <div className='countdown'>
        <div className='content'>
            <div className='box'>
                <div className='value'>
                    <span className='time'>{TimeLeft.Hours}</span>
                </div>
                <div className='label'>Hours</div>
            </div>

            <div className='colon'>:</div>

            <div className='box'>
                <div className='value'>
                    <span className='time'>{TimeLeft.Minutes}</span>
                </div>
                <div className='label'>Minutes</div>
            </div>

            <div className='colon'>:</div>

            <div className='box'>
                <div className='value'>
                    <span className='time'>{TimeLeft.Seconds}</span>
                </div>
                <div className='label'>Seconds</div>
            </div>
        </div>
    </div>
  )
}

export default Countdown;